// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import promise from 'es6-promise'
import global_ from './config.js'
promise.polyfill();

Vue.config.productionTip = false;
Vue.prototype.GLOBAL = global_;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  mode:'history',
  components: { App },
  template: '<App/>'
})
document.title = global_.full_name;


// WEBPACK FOOTER //
// ./src/main.js